import axios from "axios";
import {
    IP
} from "../index";


// 查询轮播图
export async function selectBanner() {
    var resp = await axios.post(`${IP}/admin/banner/select`, {

    });
    return resp.data;
}
// 新增轮播图
export async function addBanner(url, link, sort) {
    var resp = await axios.post(`${IP}/admin/banner/add`, {
        url,
        link,
        sort
    });
    return resp.data;
}
// 修改轮播图
export async function updateBanner(id, url, link, sort) {
    var resp = await axios.post(`${IP}/admin/banner/update`, {
        id,
        url,
        link,
        sort
    });
    return resp.data;
}
// 删除轮播图
export async function deleteBanner(id) {
    var resp = await axios.post(`${IP}/admin/banner/delete`, {
        id
    });
    return resp.data;
}